import { BCMSRecord, Workflow, useGlobalController, useParams } from "@bcm-dev/bcms-vite";
import EntitlementsPage from "components/pages/EntitlementsPage";
import PhoneNumberPage from "components/pages/PhoneNumberPage";
import UserDetailsPage from "components/pages/UserDetailsPage";
import UsersPage from "components/pages/UsersPage";
import Classes, { UserAccount } from "model";
import React from "react";

// Steps of the workflow
//const steps = [ WirePayeesPage, PayeeDetailsPage ];
const steps = [ UsersPage, PhoneNumberPage, UserDetailsPage, EntitlementsPage];

/**
 * @function AddUserWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the "Users" page.
 */
export default function AddUserWorkflow(props) {
    const controller = useGlobalController();
    const { stepID } = useParams();
    // Get the inital state of the workflow
    const value = getDefault(controller);
    // Return the workflow component
    return <Workflow value={ value } steps={ steps } step={ stepID } />;
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);
    // Return the default workflow state
    return { 
        data: {
            selectedUserAccountID: undefined,
            userAccounts: UserAccount.initAll()
        }
    };
};